import Polyhedron from "./Polyhedron.js";
// Based on: https://extremelearning.com.au/how-to-evenly-distribute-points-on-a-sphere-more-effectively-than-the-canonical-fibonacci-lattice/
export function createSphere(options) {
    const n = options.nFaces;
    let epsilon;
    if (n >= 600000) {
        epsilon = 214;
    }
    else if (n >= 400000) {
        epsilon = 75;
    }
    else if (n >= 11000) {
        epsilon = 27;
    }
    else if (n >= 890) {
        epsilon = 10;
    }
    else if (n >= 177) {
        epsilon = 3.33;
    }
    else if (n >= 24) {
        epsilon = 1.33;
    }
    else {
        epsilon = 0.33;
    }
    const goldenRatio = (1 + Math.sqrt(5)) / 2;
    const theta = new Array(n).fill(0);
    const phi = new Array(n).fill(0);
    for (let i = 0; i < n; i++) {
        theta[i] = (2 * Math.PI * i) / goldenRatio;
        phi[i] = Math.acos(1 - (2 * (i + epsilon)) / (n - 1 + 2 * epsilon));
    }
    const points = theta.map((t, index) => {
        const p = phi[index];
        return {
            x: Math.cos(t) * Math.sin(p),
            y: Math.sin(t) * Math.sin(p),
            z: Math.cos(p),
        };
    });
    const polyhedron = new Polyhedron({});
    for (let i = 0; i < n; i++) {
        const p = points[i];
        polyhedron.intersectWithPlane(p.x, p.y, p.z, -1);
    }
    return polyhedron;
}
//# sourceMappingURL=shapes.js.map